import { HttpClient } from '@angular/common/http';
import {
  AfterViewInit,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild
} from '@angular/core';
import { MatDialog } from '@angular/material';
import { AuthService, ConfigService } from '@lciapps/auth';
import {
  CompanyService,
  TranslationService,
  User,
  UserService
} from '@lciapps/lci-core';
import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';
import * as moment from 'moment';
import { fromEvent, merge, Subscription } from 'rxjs';
import { environment } from '../environments/environment';
import { ApplicationInsightsService } from './application-insights.service';
import { FeatureService } from './feature.service';
import { UserClaim } from './features/activities/shared/models/user-claim.enum';
import { UserEvents } from './features/activities/shared/models/user-events.enum';
import { CreateService } from './features/activities/shared/services/create.service';
import { AnalyticsService } from './google-analytics/analytics.services';
import { DataLayerCustomDimensions } from './google-analytics/data-layer-custom-dimensions';
import { AlertsComponent } from './root/alerts.component';
import { ScrollService } from './scroll.service';
@Component({
  selector: 'app-lci-web',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  private locale = 'en';
  private subscription: Subscription;
  timeOut;
  minutes: number = 1;
  seconds: number = 60;
  subscribeTimer: any;
  interval;
  @ViewChild('SessionExpiryPopup') // use the name of your template variable
  input: ElementRef;
  UserDetails;
  RoleType;
  Company;
  location;
  constructor(
    private angulartics2Gtm: Angulartics2GoogleAnalytics,
    private authService: AuthService,
    private userService: UserService,
    private configService: ConfigService,
    private translationService: TranslationService,
    private featureService: FeatureService,
    private companyService: CompanyService,
    private http: HttpClient,
    private scrollService: ScrollService,
    private dialog: MatDialog,
    private insightsService: ApplicationInsightsService,
    private createService: CreateService,
    public customService: AnalyticsService
  ) { }

  /**
   * ng hook
   */
  public ngOnInit(): void {
    this.featureService.addFeatureRoutes();
    this.loadTranslations();
    this.runAuthCheck();
    this.setCustomHeaders();
    this.scrollService.setScrollTop();
  }

  private loadTranslations(): void {
    this.http
      .get(`${environment.apiRootUrl}languageheader`)
      .subscribe((header: string) => {
        let code = 'en';
        if (header) {
          code = header.split(',')[0];
          if (~code.indexOf('-') && !code.startsWith('zh')) {
            code = code.split('-')[0];
          } else if (code.startsWith('zh')) {
            code = code;
          }
        }
        this.locale = code;
        this.translationService.setLocale(this.locale).subscribe();
        this.translationService
          .getTranslationValue('lblOldPassword')
          .subscribe((res) => {});});
  }

  private runAuthCheck() {
    this.authService.loggedIn$.subscribe((res) => {
      if (res) {
        this.userService.getMe().subscribe((user) => {
          //  this.GaUserInformation(user);
          this.getMemberType(user);
          this.http
            .get(`${environment.configApi}assets`)
            .subscribe((assets: any[]) => {
              const authTimeCheckAsset = assets.find(
                (a) => a.assetName === 'AuthTimeCheck'
              );

              const authTimeCheck = moment.unix(authTimeCheckAsset.assetType);
              const tokenObj = JSON.parse(
                window.atob(this.authService.user.access_token.split('.')[1])
              );
              const userLoginTime = moment.unix(tokenObj.auth_time);

              if (authTimeCheck > userLoginTime) {
                this.insightsService.clearUserId();
                this.authService.manager.signoutRedirect();
              } else {
                this.insightsService.setUserInfo(
                  user.email,
                  user.id,
                  this.authService.user.session_state
                );
                this.insightsService.trackEvent(UserEvents.HomePageLoaded, {
                  userId: user.id,
                });
              }
            });

          // this.loadAlerts(user);
          this.featureService.getZendeskUrl().subscribe();

          const clubCompanyIds = this.createService.getClaimValues(
            user.claims,
            [UserClaim.CanReportActivity, UserClaim.ClubMembership]
          );
          const myLionIds = this.createService.getClaimValues(user.claims, [
            UserClaim.MyLion,
          ]);
          const companyIdInt =
            clubCompanyIds == null || clubCompanyIds.length === 0
              ? myLionIds
              : clubCompanyIds;
          if (companyIdInt && companyIdInt.length > 0) {
            this.companyService.getCompany(companyIdInt[0]).subscribe();
          }
        });
      }
    });
  }
  ngAfterViewInit() {
    this.watchSession(1800000);
    const $focusEvent = fromEvent(document, 'scroll');
    const $clickEvent = fromEvent(document, 'click');
    const $keyEvent = fromEvent(document, 'keyup');
    const $allEvent = merge($focusEvent, $clickEvent, $keyEvent);
    this.subscription = $allEvent.subscribe((val) => {
      clearTimeout(this.timeOut);
      this.watchSession(1800000);
    });
  }
  private loadAlerts(user: User) {
    this.featureService.getAlerts(user.id).subscribe((alerts) => {
      alerts = alerts.filter((alert) => {
        return alert.viewStatus !== 'Viewed';
      });
      if (alerts.length) {
        this.loadAlertDialog(user, alerts);
      }
    });
  }

  public loadAlertDialog(user: User, alerts: Array<any>) {
    const alert: any = alerts.splice(0, 1);

    const dialogRef = this.dialog.open(AlertsComponent, {
      width: '400px',
      data: alert[0],
    });
    dialogRef.afterClosed().subscribe((res) => {
      this.featureService
        .viewAlert(user.id, alert[0].id)
        .subscribe((alertRes) => {
          if (alerts.length) {
            this.loadAlertDialog(user, alerts);
          }
        });
    });
  }

  private setCustomHeaders() {
    const headers = {
      Language: () => {
        return this.locale;
      },
    };
    this.configService.setInterceptorHeaders('apiurl://', headers);
    this.configService.setInterceptorHeaders('apirooturl://', headers);
    this.configService.setInterceptorHeaders('reportingApi://', headers);
    this.configService.setInterceptorHeaders('mobileapi://', headers);
  }
  watchSession(time) {
    this.timeOut = setTimeout(() => {
      this.timerDialog(this.input);
    }, time);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
  timerDialog(template) {
    this.dialog.open(template, {
      width: '280px',
      panelClass: 'session-dialog-box',
    });
    setTimeout(() => {
      this.startTimer();
    }, 100);
  }

  startTimer() {
    this.interval = setInterval(() => {
      if (this.seconds > 0) {
        this.seconds--;
      } else if (this.minutes === 0) {
        clearInterval(this.interval);
        clearTimeout(this.timeOut);
        this.authService.manager.signoutRedirect();
      } else {
        this.seconds = 60;
        this.minutes--;
      }
    }, 1000);
  }

  continueSession() {
    clearInterval(this.interval);
    clearTimeout(this.timeOut);
    this.minutes = 1;
    this.seconds = 60;
    this.watchSession(1800000);
    this.dialog.closeAll();
  }
  exitSession() {
    this.dialog.closeAll();
    clearInterval(this.interval);
    clearTimeout(this.timeOut);
    this.authService.manager.signoutRedirect();
  }

  getMemberType(user) {
    if (user) {
      this.UserDetails = user;
      const role = this.UserDetails.userProfile.isOfficer
        ? 'Officer'
        : 'Non-Officer';
      this.RoleType = role;

      const userRolesObj = this.UserDetails.claims.find(
        (c) => c.claimType === UserClaim.MemberRole
      );

      if (userRolesObj.claimValue === UserClaim.Guest) {
        //this.UserName = this.UserDetails.userProfile.firstName;
        // this.updateUsername.emit(this.UserName);
        // this.displayUsername(this.UserName);
        this.featureService.GaMemberShipType = `Non Member - ${role}`;
        this.SetGaInfo(`Non Member - ${role}`);
      } else if (userRolesObj.claimValue === UserClaim.Member) {
        let companyId;
        if(user && user.userProfile && user.userProfile.companyId)
        {
          companyId =user.userProfile.companyId;
        }
        else{
          companyId = this.createService.getClaimValues(this.UserDetails.claims, [UserClaim.ClubMembership]);
        }
        this.featureService
          .companyDetails(companyId)
          .subscribe((companydata) => {
            if (companydata) {
              this.Company = companydata;
              if (
                this.Company.companyType === 'Lions Club' ||
                this.Company.companyType === 'Leo Lions Club'
              ) {
                this.featureService.GaMemberShipType = 'Lion Member';
                this.SetGaInfo('Lion Member');
              } else if (
                this.Company.companyType === 'Leo Club' ||
                this.Company.companyType === 'Alpha Leo Club' ||
                this.Company.companyType === 'Omega Leo Club' ||
                this.Company.companyType === 'Leo District' ||
                this.Company.companyType === 'Leo Multiple District'
              ) {
                this.featureService.GaMemberShipType = 'Leo Member';
                this.SetGaInfo('Leo Member');
              } else {
                const member = this.UserDetails.userProfile.membershipType
                  ? 'Member'
                  : 'Non-Member';
              }
              //   this.updateUsername.emit(this.UserName);
              //  this.displayUsername(this.UserName);
            }
          });
      }
    }
  }
  SetGaInfo(membershipType) {
    let location;
    if (
      !this.UserDetails.userProfile.caName &&
      !this.UserDetails.userProfile.multipleDistrictName &&
      !this.UserDetails.userProfile.districtName
    ) {
      location = 'No User Location Available';
    } else {
      location = `${this.UserDetails.userProfile.caName}, ${this.UserDetails.userProfile.multipleDistrictName}, ${this.UserDetails.userProfile.districtName}`;
    }
    this.customService.pageView({
      [DataLayerCustomDimensions.Location]: location,
      [DataLayerCustomDimensions.RolesType]: this.RoleType,
      [DataLayerCustomDimensions.MemebershipType]: membershipType,
      [DataLayerCustomDimensions.appName]:"Mylion",
      [DataLayerCustomDimensions.caName]: this.UserDetails.userProfile.caName ? this.UserDetails.userProfile.caName : "No User Location Available",
      [DataLayerCustomDimensions.multipleDistrictName]: this.UserDetails.userProfile.multipleDistrictName ? this.UserDetails.userProfile.multipleDistrictName : "No User Location Available",
      [DataLayerCustomDimensions.districtName]: this.UserDetails.userProfile.districtName ? this.UserDetails.userProfile.districtName : "No User Location Available",
      [DataLayerCustomDimensions.event]: 'UserInfoEvent',
      [DataLayerCustomDimensions.eventAction]: 'UserInfo',
      [DataLayerCustomDimensions.eventCategory]: 'UserInformation',
      [DataLayerCustomDimensions.eventLabels]: 'UserInfoLabels',
    });
  }
}
